import { render, staticRenderFns } from "./ProcessDetail.vue?vue&type=template&id=65aa68ae&"
import script from "./ProcessDetail.vue?vue&type=script&lang=js&"
export * from "./ProcessDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProcessDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProcessDetail.vue"
export default component.exports